//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import {BFormGroup, BFormInput, BFormTextarea, BSpinner} from 'bootstrap-vue'

import { validationMixin } from 'vuelidate'
import {required, minLength, email, sameAs} from "vuelidate/lib/validators"

export default {

    name: 'CreateMeetingContact',

    mixins: [validationMixin],

    components: { BFormGroup, BFormInput, BFormTextarea, BSpinner },

    props: {
        company: {},
        contactData: {
            type: Object,
            default: {
                firstName: '',
                lastName: '',
                email: '',
                emailConfirm: '',
                eventName: '',
                eventDescription: '',
            }
        }
    },

    data() {
        return {
            firstName: this.contactData.firstName,
            lastName: this.contactData.lastName,
            email: this.contactData.email,
            emailConfirm: this.contactData.emailConfirm,
            eventName: this.contactData.eventName,
            eventDescription: this.contactData.eventDescription,
        };
    },

    validations: {
        firstName: {
            required,
            minLength: minLength(4),
        },
        lastName: {
            required,
            minLength: minLength(4),
        },
        email: {
            required,
            email,
        },
        emailConfirm: {
            required,
            email,
            sameAsEmail: sameAs('email')
        },
        eventName: {
            required,
        },
        eventDescription: {
            required,
        },
    },

    created() {

        if(this.$helper.empty(this.contactData) && this.$auth.loggedIn) {

            this.firstName = this.$auth.user.firstName
            this.lastName = this.$auth.user.name
            this.email = this.$auth.user.email
            this.emailConfirm = this.$auth.user.email

        }


    },


    methods: {

        getState(field) {

            if(field.$dirty === false) {
                return null
            }

            return !field.$error
        },

        getData() {

            const data = {
                firstName: this.firstName,
                lastName: this.lastName,
                email: this.email,
                emailConfirm: this.emailConfirm,
                eventName: this.eventName,
                eventDescription: this.eventDescription,
            }

            return data

        },

        onBack() {

            const data = this.getData()

            this.$emit('back', data)

        },

        onSubmit() {

            this.$v.$touch();

            if (this.$v.$invalid) {
                this.$toast.global.my_error({message: 'Please fill all required fields'})
                return false;
            } else {
                this.$waiter.start('search/submit-request')
                const data = this.getData()
                this.$emit('submit', data)
            }
        },

    },

    computed: {

        isLoading() {
            return this.$waiter.has('search/submit-request')
        }

    }
};
